import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const FRAMES = [
  { img: "/images/house-2.webp", caption: "Whole-Home Deep Cleans", lift: "lg:mt-10" },
  { img: "/images/house-3.webp", caption: "Sparkling Tile & Glass", lift: "" },
  { img: "/images/house-1.webp", caption: "Guest-Ready, Every Corner", lift: "lg:mt-14" },
];

export default function HeroStrip() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [30, -30]);

  return (
    <section ref={ref} data-testid="hero-photo-strip" className="relative bg-[#FDFBF7] pb-20 lg:pb-24 -mt-4">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div style={{ y }} className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8">
          {FRAMES.map((f, i) => (
            <motion.figure
              key={f.img}
              data-testid={`hero-strip-frame-${i}`}
              initial={{ opacity: 0, y: 60, rotate: 0 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: i * 0.15 }}
              className={`group ${f.lift}`}
            >
              <div className="overflow-hidden rounded-2xl border-4 border-white shadow-xl shadow-[#0F172A]/10 group-hover:scale-[1.03] transition-transform duration-500">
                <img
                  src={f.img}
                  alt={f.caption}
                  loading="lazy"
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-[1.2s] ease-out"
                />
              </div>
              <figcaption className="mt-3 text-center font-jet text-[10px] uppercase tracking-[0.25em] text-[#993B19]">
                {f.caption}
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
